import { render, staticRenderFns } from "./facility-with-unit-field.vue?vue&type=template&id=600b7700&scoped=true"
import script from "./facility-with-unit-field.vue?vue&type=script&lang=js"
export * from "./facility-with-unit-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600b7700",
  null
  
)

export default component.exports